import { Model } from "vuex-fetch-factory";

export interface LicenseRaw {
  relation_id: number;
  bundle: string;
  cloud: boolean;
  no_of_users: number;
  no_of_app_users: number;
  base: boolean;
  app: boolean;
  soap: boolean;
  project: boolean;
  invoice: boolean;
  orders: boolean;
  quotations: boolean;
  outlook: boolean;
  procedures: boolean;
  planner: boolean;
  emailing: boolean;
  specific_fields: boolean;
  tapi: boolean;
  fin_exact: boolean;
  fin_exact_online: boolean;
  fin_snelstart: boolean;
  fin_snelstart_online: boolean;
  fin_twinfield: boolean;
  automatic_collection: boolean;
  multi_language: boolean;
  logistics_active: boolean;
  logistics_licensed: boolean;
  multi_admin_active: boolean;
  multi_admin_licensed: boolean;
  multi_invoice_active: boolean;
  multi_invoice_licensed: boolean;
}

export class LicenseModel implements Model<LicenseModel, LicenseRaw> {
  public relation_id = 0;
  public bundle = "";
  public cloud = false;
  public no_of_users = 0;
  public no_of_app_users = 0;
  public base = false;
  public app = false;
  public soap = false;
  public project = false;
  public invoice = false;
  public orders = false;
  public quotations = false;
  public outlook = false;
  public procedures = false;
  public planner = false;
  public emailing = false;
  public specific_fields = false;
  public tapi = false;
  public fin_exact = false;
  public fin_exact_online = false;
  public fin_snelstart = false;
  public fin_snelstart_online = false;
  public fin_twinfield = false;
  public automatic_collection = false;
  public multi_language = false;
  public logistics_active = false;
  public logistics_licensed = false;
  public multi_admin_active = false;
  public multi_admin_licensed = false;
  public multi_invoice_active = false;
  public multi_invoice_licensed = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;

  public getNew(): LicenseModel {
    return new LicenseModel();
  }

  public fillModel(raw: LicenseRaw): this {
    this.relation_id = raw.relation_id;
    this.bundle = raw.bundle;
    this.cloud = raw.cloud;
    this.no_of_users = raw.no_of_users;
    this.no_of_app_users = raw.no_of_app_users;
    this.base = raw.base;
    this.app = raw.app;
    this.soap = raw.soap;
    this.project = raw.project;
    this.invoice = raw.invoice;
    this.orders = raw.orders;
    this.quotations = raw.quotations;
    this.outlook = raw.outlook;
    this.procedures = raw.procedures;
    this.planner = raw.planner;
    this.emailing = raw.emailing;
    this.specific_fields = raw.specific_fields;
    this.tapi = raw.tapi;
    this.fin_exact = raw.fin_exact;
    this.fin_exact_online = raw.fin_exact_online;
    this.fin_snelstart = raw.fin_snelstart;
    this.fin_snelstart_online = raw.fin_snelstart_online;
    this.fin_twinfield = raw.fin_twinfield;
    this.automatic_collection = raw.automatic_collection;
    this.multi_language = raw.multi_language;
    this.logistics_active = raw.logistics_active;
    this.logistics_licensed = raw.logistics_licensed;
    this.multi_admin_active = raw.multi_admin_active;
    this.multi_admin_licensed = raw.multi_admin_licensed;
    this.multi_invoice_active = raw.multi_invoice_active;
    this.multi_invoice_licensed = raw.multi_invoice_licensed;
    return this;
  }

  public getRaw(): LicenseRaw {
    return {
      relation_id: this.relation_id,
      bundle: this.bundle,
      cloud: this.cloud,
      no_of_users: this.no_of_users,
      no_of_app_users: this.no_of_app_users,
      base: this.base,
      app: this.app,
      soap: this.soap,
      project: this.project,
      invoice: this.invoice,
      orders: this.orders,
      quotations: this.quotations,
      outlook: this.outlook,
      procedures: this.procedures,
      planner: this.planner,
      emailing: this.emailing,
      specific_fields: this.specific_fields,
      tapi: this.tapi,
      fin_exact: this.fin_exact,
      fin_exact_online: this.fin_exact_online,
      fin_snelstart: this.fin_snelstart,
      fin_snelstart_online: this.fin_snelstart_online,
      fin_twinfield: this.fin_twinfield,
      automatic_collection: this.automatic_collection,
      multi_language: this.multi_language,
      logistics_active: this.logistics_active,
      logistics_licensed: this.logistics_licensed,
      multi_admin_active: this.multi_admin_active,
      multi_admin_licensed: this.multi_admin_licensed,
      multi_invoice_active: this.multi_invoice_active,
      multi_invoice_licensed: this.multi_invoice_licensed
    };
  }

  public get activeModules(): string[] {
    const inst = this;
    return Object.keys(inst).filter((key): boolean => {
      const prop = inst[key];
      return typeof prop === "boolean" && prop === true;
    });
  }

  public get bundleName(): string {
    switch (this.bundle) {
      case "lite":
        return "Lite";
      case "complete":
        return "Alles-In-Eén";
      case "a-la-carte":
        return "Extra mogelijkheid";
      default:
        return "Onbekend";
    }
  }
}
